//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitJoin.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[0,"BasePlane",1,"ISurface",0],[0,"ChordalTolerance",1,0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"CurveFitJoinOptions",0,"GeometricUtilities.CurveFitJoin",0],[1,"CurveForPerpendicularPlane",0,"SelectObject",0],[0,"EndAngle",1,0],[0,"EndDistance",1,0],[0,"EndPercentage",1,0],[0,"GroupObjects",1,0],[0,"Increment",1,0],[0,"NumberOfCopies",1,0],[1,"ObjectsToSection",0,"SelectObjectList",0],[0,"OutputPoints",1,0],[0,"RadialPlanePoint",1,"Point",0],[0,"RadialPlaneVector",1,"Direction",0],[0,"Ratio",1,0],[0,"SampleDistance",1,0],[0,"SectionPlane",1,"Plane",0],[1,"SectionPlanes",0,"SelectObjectList",0],[0,"SpacingAlongCurveType",1,0],[0,"StartAngle",1,0],[0,"StartDistance",1,0],[0,"StartPercentage",1,0],[0,"StepAngle",1,0],[0,"StepDistance",1,0],[0,"Tolerance",1,0],[0,"Type",1,0]],[[["num_group"],"GetOutputGroups",{R_:{groups:"Group[]"}},0,0]],[]];
SPLM.Features.SectionCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SectionCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SectionCurveBuilder.PlaneType = Object.freeze({
    "Selected" : "Selected", "Parallel" : "Parallel", "Radial" : "Radial", "PerpendicularToCurve" : "PerpendicularToCurve"});

SPLM.Features.SectionCurveBuilder.SpacingType = Object.freeze({
    "EqualArcLength" : "EqualArcLength", "EqualParameterSpacing" : "EqualParameterSpacing", "GeometricProgressionSpacing" : "GeometricProgressionSpacing", "ChordalToleranceSpacing" : "ChordalToleranceSpacing", "IncrementalArclengthSpacing" : "IncrementalArclengthSpacing"});

export default SPLM;